import { FC } from 'react';
import { useTranslation, Card } from '@packages/utils';
import { useTheme } from 'styled-components';
import { Col, Row } from 'components/Base/Grid';
import { Divider } from 'components/Base/Divider';
import { Select } from 'components/Base/Select';
import { EAttendanceStatus } from 'data/types/registrants.types';
import { Switch } from 'components/Base/Switch';
import { TUpdateAttendanceItemProps } from './UpdateAttendanceItem.types';
import { FirstCol, SecondCol } from '../UpdateAttendancesModal.styles';
import AttendanceText from '../../components/AttendanceText';

const UpdateAttendanceItem: FC<TUpdateAttendanceItemProps> = ({
  attendance,
  onSelect,
  onKitCountChange,
}) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const {
    partType,
    isUpdatable,
    kitCount = 0,
    attendanceStatus,
    sessionAttendanceId,
  } = attendance;

  if (!isUpdatable) {
    return null;
  }

  const effectiveKitCount = kitCount ?? 0;

  return (
    <Col className="w-100 px-0">
      <Card
        styles={{
          body: {
            padding: '4px 12px',
          },
        }}
        className="mb-2"
      >
        <Row wrap={false} align="middle">
          <FirstCol>
            <AttendanceText
              text={t(`enums.workshop-part-type.${partType}`)}
              color={theme.colorPurpleDefault}
            />
          </FirstCol>
          <Divider type="vertical" thickness={3} height={30} />
          <SecondCol>
            <Select
              options={Object.values(EAttendanceStatus).map(status => ({
                label: t(`enums.attendance-status.${status}`),
                value: status,
              }))}
              className="w-100"
              placeholder={t(
                'descriptions.admin-portal.workshops.details.workshop-registrants.actions.edit.modal.attendance-chart.attendance-input.PLACEHOLDER',
              )}
              placement="topLeft"
              value={attendanceStatus}
              onSelect={value => {
                onSelect(sessionAttendanceId, value);
              }}
            />
          </SecondCol>
          <Divider type="vertical" thickness={3} height={30} />
          <Col>
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={effectiveKitCount >= 1}
              disabled={attendanceStatus === EAttendanceStatus.ABSENT}
              onChange={checked => {
                const newKitCount = checked ? 1 : 0;
                onKitCountChange(sessionAttendanceId, newKitCount);
              }}
            />
          </Col>
        </Row>
      </Card>
    </Col>
  );
};

export default UpdateAttendanceItem;
